import {IStore} from "modules/types";

export const isAuthedSelector = ({user}: IStore) => user.isAuthenticated;
export const getIsNeedToRegisterSelector = ({user}: IStore) => user.isNeedToRegister;
export const getGigyaDataSelector = ({user}: IStore) => user.gigyaData;
export const getUserDataSelector = ({user}: IStore) => user.user;
